module.exports = __webpack_public_path__ + "img/download.1015f8c2.jpg";